import {getAPIDomain} from '../config/constants'
const apiUrl = `${getAPIDomain()}/api/contacts`;
const authToken = "authToken";
const getAuthHeader = ()=>{
    if(localStorage.getItem(authToken)){
        return "JWT "+localStorage.getItem(authToken);
    }else{
        window.location = "/login";
    }
}
export const uploadFile = async (formData) =>{
      return fetch( `${apiUrl}/upload-xlsx`, {
      method: "POST",
      headers: {
        "Authorization":getAuthHeader()
      },
      body:formData
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
};